"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@tiendanube/icons");
var __1 = require("..");
var utils_1 = require("./utils");
function Item(_a) {
    var title = _a.title, description = _a.description, labels = _a.labels, value = _a.value, checked = _a.checked, skeleton = _a.skeleton, hideBorder = _a.hideBorder, onChange = _a.onChange, icon = _a.icon, iconAppearance = _a.iconAppearance;
    var mainClass = classnames_1.default("nimbus--interactive-list-item", {
        "nimbus--interactive-list-item__borderBottom": hideBorder,
    });
    var id = "input_" + title;
    var handleChange = function (event) {
        var target = event.target;
        onChange({ name: target.value, checked: target.checked });
    };
    return (React.createElement("label", { htmlFor: id, className: mainClass, role: "listitem" },
        React.createElement("div", { className: "nimbus--interactive-list-item__wrapper--all" },
            React.createElement("div", { className: "nimbus--interactive-list-item__wrapper--upper" },
                utils_1.renderIcon(icon, iconAppearance),
                React.createElement("div", { className: "nimbus--interactive-list-item__title" },
                    skeleton ? React.createElement(__1.Text.Skeleton, null) : React.createElement(__1.Text, null, title),
                    React.createElement("div", { className: "nimbus--radio-wrapper" }, skeleton ? (React.createElement(__1.Checkbox.Skeleton, null)) : (React.createElement(React.Fragment, null,
                        React.createElement("input", { type: "radio", id: id, value: value, checked: checked, onChange: handleChange, className: "nimbus--radio" }),
                        React.createElement("div", { className: "nimbus--radio-label" }),
                        checked && (React.createElement("div", { className: "nimbus--radio__check" },
                            React.createElement(icons_1.CheckIcon, null)))))))),
            utils_1.renderBelow(description, labels))));
}
exports.default = Item;
//# sourceMappingURL=InteractiveListPriv.RadioItem.js.map